module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_1-2fdd3fd06124301b35e6e9e7f3b82cb9.png";